var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchase24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7539 3V12.75",
    stroke: "current",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3902 9.2998L13.0902 12.5998C12.8872 12.8029 12.6147 12.7993 12.4152 12.5998L9.11523 9.2998",
    stroke: "current",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.25C7.95 17.25 8.25 17.55 8.25 18C8.25 18.45 7.95 18.75 7.5 18.75C7.05 18.75 6.75 18.45 6.75 18C6.75 17.55 7.05 17.25 7.5 17.25ZM7.5 15.75C6.225 15.75 5.25 16.725 5.25 18C5.25 19.275 6.225 20.25 7.5 20.25C8.775 20.25 9.75 19.275 9.75 18C9.75 16.725 8.775 15.75 7.5 15.75Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.25C18.45 17.25 18.75 17.55 18.75 18C18.75 18.45 18.45 18.75 18 18.75C17.55 18.75 17.25 18.45 17.25 18C17.25 17.55 17.55 17.25 18 17.25ZM18 15.75C16.725 15.75 15.75 16.725 15.75 18C15.75 19.275 16.725 20.25 18 20.25C19.275 20.25 20.25 19.275 20.25 18C20.25 16.725 19.275 15.75 18 15.75Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.25C7.91421 8.25 8.25 7.91421 8.25 7.5C8.25 7.08579 7.91421 6.75 7.5 6.75C7.08579 6.75 6.75 7.08579 6.75 7.5C6.75 7.91421 7.08579 8.25 7.5 8.25Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75635 7.93378C5.30719 5.95749 3.5905 4.5 1.5 4.5V6C2.85702 6 3.98867 6.93907 4.292 8.25898L6.01533 16.6509L6.13837 17.25H6.75H16.35C18.1157 17.25 19.6151 16.045 20.0013 14.3637L22.0203 7.5H20.4567L18.5555 13.9633L18.5483 13.9876L18.5429 14.0123C18.3195 15.0175 17.4252 15.75 16.35 15.75H7.36163L5.75967 7.94913L5.75809 7.94144L5.75635 7.93378Z",
    className: "filled",
    fill: "current",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase24);
export default __webpack_public_path__ + "static/media/Purchase-24.695ed14e.svg";
export { ForwardRef as ReactComponent };